import { useId } from "react";

import { cn } from "@/lib/utils";

export function DudeIcon({ className, ...props }: React.ComponentProps<"svg">) {
  const id = useId();

  return (
    <svg
      aria-hidden="true"
      className={cn("aspect-279/429 w-[279px]", className)}
      fill="none"
      viewBox="0 0 279 429"
      {...props}
    >
      <circle cx="174.437" cy="20.897" fill="#F7F7F7" r="9.835" />
      <circle cx="135.258" cy="31.898" fill="#F7F7F7" r="6.641" />
      <path
        d="M71.285 132.164l35.69.298-8.83-22.103-21.126.568a.804.804 0 01-.557-.205L44.599 82.047c1.318-.006 4.22-1.134 5.285-5.59 1.065-4.454-1.868-4.94-3.468-4.626-.505 1.859-1.907 5.37-3.476 4.54-1.961-1.037-1.348-9.676-7.378-13.193-6.03-3.517-15.383-3.86-18.235 1.535-2.283 4.316 5.23 14.229 8.54 16.801l36.067 46.047a12.008 12.008 0 009.352 4.603zm46.064 262.964h17.372v23.646h-17.372zm62.458 0h17.372v23.646h-17.372z"
        fill="#F3898A"
      />
      <path
        d="M176.378 195.019c-18.752-4.46-67.247 0-67.247 0-6.683 60.039-.521 177.205 4.478 212.346h23.843l7.471-154.087c9.292 31.789 22.302 120.661 30.022 154.087h24.962s-4.777-207.886-23.529-212.346z"
        fill="#fff"
      />
      <path
        clipRule="evenodd"
        d="M145.863 256.649l-7.754-37.94 4.107 90.346 2.704-55.777c.311 1.062.625 2.187.943 3.371z"
        fill="#E6CFFF"
        fillRule="evenodd"
      />
      <path
        d="M181.543 202.186h-72.924l1.135-10.613c21.713-1.39 64.136-2.563 65.247-2.069 1.111.494 5.461 9.749 6.542 12.682z"
        fill="#4D0D54"
      />
      <path
        d="M142.663 194.234h2.984v9.047h-2.984zm22.229 0h2.984v9.047h-2.984z"
        fill="#fff"
      />
      <path
        clipRule="evenodd"
        d="M137.461 71.966v-.029c-.752.332-1.664.668-2.724 1.057-7.827 2.877-23.712 8.714-42.61 38.147 1.32 5.716 6.332 17.853 15.83 20.667a222.07 222.07 0 013.633-6.095c-4.241 27.066-4.451 56.823-3.387 69.677H183.6c0-24.461 1.398-47.532 3.457-66.582a634.536 634.536 0 0014.322 16.528l20.728-24.2c-12.046-18.571-22.202-33.977-32.592-41.77-12.642-10.604-36.562-14.266-52.054-7.4z"
        fill={`url(#${id}a)`}
        fillRule="evenodd"
      />
      <path
        d="M149.537 99.607l-4.861-5.25 4.349-8.033 1.516.394 4.57 6.388-5.574 6.501z"
        fill="#4D0D54"
      />
      <path
        d="M140.851 181.408l7.048-87.656h3.678v87.656l-6.485 11.31-4.241-11.31z"
        fill="#4D0D54"
      />
      <path
        d="M144.431 71.623c-6.781 19.587 14.564 20.09 26.617 0v-27.12h-26.617v27.12z"
        fill="#F3898A"
      />
      <path
        clipRule="evenodd"
        d="M144.432 64.434c.096.481.199.977.31 1.487 2.698 12.464 18.451-.834 26.054-7.527.087-.072.172-.143.253-.213v-4.82c-3.95-2.272-14.141-3.121-22.307-3.801-1.408-.118-2.755-.23-4-.343a.89.89 0 00-.31.188v15.029z"
        fill="#CE5E60"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M219.501 122.561l-14.886 18.566 25.918 12.198c5.174 2.435 11.304-.295 12.954-5.77l16.638-55.183c3.926-1.468 6.917-7.457 6.025-12.257-1.114-6-3.156-13.466-10.019-12.192-3.807.707-5.307 5.728-6.431 9.489-.673 2.251-1.211 4.051-2.027 4.203-1.745.324-2.13-2.839-2.058-4.764-1.433-.777-4.2-1.338-4.512 3.233-.312 4.57 6.773 8.99 8.029 9.39l-20.529 36.49a.801.801 0 01-1.034.334l-8.068-3.737z"
        fill="#F3898A"
        fillRule="evenodd"
      />
      <path
        d="M156.386 98.966c24.211-20.621 18.431-32.25 14.677-35.074-2.822 11.023-17.191 21.036-20.874 22.824l6.197 12.25zm-13.197-.803l6.897-11.637c-3.078-2.072-5.766-11-5.545-14.878v-4.101c-10.505 6.947-4.176 26.254-1.352 30.616z"
        fill="#6EC7F6"
      />
      <path
        d="M134.244 33.029c0-10.953 4.005-17.765 14.958-17.765s24.705 6.812 24.705 17.765V44.06c0 10.952-8.879 19.831-19.831 19.831-10.953 0-19.832-8.879-19.832-19.831V33.029z"
        fill="#F3898A"
      />
      <path
        d="M161.643 28.992c-11.359-3.207-17.217 2.788-26.715 0-5.061-3.653-3.66-7.866 3.436-11.07 17.028-7.687 30.415-.299 35.341 5.808 1.684 2.088 6.917.556 6.917 10.084 0 9.529-9.332 22.157-11.096 22.487 3.002-2.479.714-13.096 0-15.165-1.429-4.142-1.927 0-1.927 0s-5.956.876-5.956-12.144zm-27.424 12.963v-10.86l-2.919-3.31c.159 7.62 2.158 12.483 2.919 14.17z"
        fill="#F7F7F7"
      />
      <ellipse
        cx="170.745"
        cy="42.896"
        fill="#F3898A"
        rx="3.983"
        ry="7.18"
        transform="rotate(11.088 170.745 42.896)"
      />
      <path d="M117.41 194.234h2.984v9.047h-2.984z" fill="#fff" />
      <path
        d="M84.652 424.849l32.958-13.465c6.313 5.76 11.768 2.619 15.646.33 1.204-.71 3.671-.33 3.671-.33v17.098H85.366c-2.07 0-2.63-2.851-.714-3.633z"
        fill={`url(#${id}b)`}
      />
      <path
        d="M147.254 424.849l32.957-13.465c6.314 5.76 11.769 2.619 15.646.33 1.205-.71 3.672-.33 3.672-.33v17.098h-51.562c-2.069 0-2.629-2.851-.713-3.633z"
        fill={`url(#${id}c)`}
      />
      <circle cx="133.289" cy="20.087" fill="#F7F7F7" r="6.641" />
      <circle cx="143.548" cy="11.968" fill="#F7F7F7" r="9.304" />
      <circle cx="157.088" cy="9.304" fill="#F7F7F7" r="9.304" />
      <circle cx="170.043" cy="15.377" fill="#F7F7F7" r="10.05" />
      <ellipse
        cx="5.606"
        cy="5.771"
        rx="5.606"
        ry="5.771"
        stroke="#fff"
        strokeLinecap="round"
        strokeWidth="1.418"
        transform="scale(-1 1) rotate(-8.075 173.841 1147.686)"
      />
      <ellipse
        cx="5.606"
        cy="5.771"
        rx="5.606"
        ry="5.771"
        stroke="#fff"
        strokeLinecap="round"
        strokeWidth="1.418"
        transform="scale(-1 1) rotate(-8.075 183.652 1044.38)"
      />
      <path
        d="M143.585 38.722l3.97.042m10.696-.781l9.029-.757"
        stroke="#fff"
        strokeLinecap="round"
        strokeWidth="1.418"
      />
      <defs>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}a`}
          x1="9.458"
          x2="183.585"
          y1="238.276"
          y2="254.861"
        >
          <stop stopColor="#43C9FF" />
          <stop offset="0.995" stopColor="#586AFF" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}b`}
          x1="49.481"
          x2="116.165"
          y1="434.294"
          y2="453.567"
        >
          <stop stopColor="#43C9FF" />
          <stop offset="0.995" stopColor="#586AFF" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}c`}
          x1="112.083"
          x2="178.767"
          y1="434.294"
          y2="453.567"
        >
          <stop stopColor="#43C9FF" />
          <stop offset="0.995" stopColor="#586AFF" />
        </linearGradient>
      </defs>
    </svg>
  );
}
